import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { useIconSectionColor, useItemsInRow } from '../../../../helpers';
import { Icon } from '../../../common';
import { ItemLayout } from '../items-layouts';
import { useData } from '../main-layouts';
import { SectionsTitle } from './SectionsTitle';
import { SectionsControl } from './sections-control';

export function SectionsLayoutTabs() {
  const {
    showSectionsTitle,
    sectionTitleFontStyle: { fontSize: sectionTitleFontSize }
  } = useSettings();
  const {
    metadata: { sectionsEnabled },
    selectedSection,
    itemsBySections,
    visibleSections
  } = useData();

  const [itemsCount, containerRef] = useItemsInRow();
  const iconColor = useIconSectionColor();

  if (!selectedSection) {
    return <ItemsContainer ref={containerRef}></ItemsContainer>;
  }

  const { id, name, icon } = selectedSection;
  const items = itemsBySections[selectedSection.id] ?? [];
  const showImage = items.some(({ image }) => image);
  const iconSize = sectionTitleFontSize * 1.333;

  const tabPanelProps =
    visibleSections.length > 1
      ? { role: 'tabpanel', 'aria-labelledby': id }
      : {};

  return (
    <Component>
      <Heading>
        <SectionsControl />
      </Heading>

      {sectionsEnabled && selectedSection && showSectionsTitle && (
        <StyledSectionsTitle>
          {icon && (
            <Icon
              icon={icon}
              size={iconSize}
              fill={iconColor}
              style={{ marginRight: '12px' }}
              alt=""
            />
          )}
          {name}
        </StyledSectionsTitle>
      )}

      <ItemsContainer ref={containerRef} {...tabPanelProps}>
        {items?.map((item, itemId) => (
          <ItemLayout
            data={item}
            key={itemId}
            width={100 / (itemsCount || 1)}
            showImage={showImage}
          />
        ))}
      </ItemsContainer>
    </Component>
  );
}

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ItemsContainer = styled.div`
  min-width: calc(100% + 48px);
  display: flex;
  flex-wrap: wrap;
  margin: -16px -24px;
  justify-content: center;
`;

const Heading = styled.div`
  overflow: hidden;
`;

const StyledSectionsTitle = styled(SectionsTitle)`
  justify-content: center;
`;
